import React from "react";
import { Link } from "react-router-dom";
import { createAvatar } from "@dicebear/core";
import { identicon } from "@dicebear/collection";

const Post = ({ post }) => {
  const avatar = React.useMemo(() => {
    return createAvatar(identicon, {
      seed: post.displayname,
      backgroundType: ["gradientLinear", "solid"],
    }).toDataUri();
  }, [post.displayname]);

  const formattedDateTime = new Date(post.dateTime).toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return (
    <div className="col pb-3">
      <div className="bleep-card card">
        <Link
          style={{
            textDecoration: "none",
          }}
          to={`/post/${post._id}`}
        >
          <div
            className="row align-items-center"
            style={styles.row}
          >
            <div
              className="col-10"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ffffff",
                  marginRight: "10px",
                  position: "relative", // Ensure badge does not affect layout
                }}
              >
                {/* Generated avatar */}
                <img
                  src={avatar}
                  alt="Avatar"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
                {/* Bleeps posted by user */}
                {post.userbleeps > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      backgroundColor: "#ffffff",
                      color: "black",
                      borderRadius: "10px",
                      padding: "3px 6px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "10px",
                      fontWeight: "bold",
                      boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
                    }}
                  >
                    <i
                      className="fas fa-bolt"
                      style={{ color: "#ffcc00" }}
                    ></i>
                    &nbsp;
                    {post.userbleeps}
                  </div>
                )}
              </div>

              {/* Post User details */}
              <div>
                <span
                  className="card-title fw-bold"
                  style={styles.title}
                >
                  {post.displayname}
                </span>
                <br />
                <span style={styles.date}>{formattedDateTime}</span>
              </div>
            </div>

            {/* Hidden at zero: a "0 comments" badge is not information, and on
                a grid of new bleeps it put an identical empty pill on every
                card. `> 0` also covers the field being absent. */}
            {post.comments > 0 && (
              <div
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "0 10px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    minHeight: "28px",
                    padding: "0 10px",
                    borderRadius: "999px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    fontSize: "12px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  <i className="far fa-comments" />
                  <span>{post.comments}</span>
                </div>
              </div>
            )}
          </div>

          <div>
            <div
              style={{
                position: "absolute",
                top: 230,
                left: 20,
                zIndex: 100,
                display: "flex",
                flexDirection: "row",
                gap: 5,
              }}
            >
              {post.audio && (
                <div
                  style={{
                    backgroundColor: "#ff8c00",
                    color: "black",
                    borderRadius: 10,
                    width: 30,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
                  }}
                >
                  <i className="fas fa-microphone"></i>
                </div>
              )}
              {post.video && (
                <div
                  style={{
                    backgroundColor: "#ffd900",
                    color: "black",
                    borderRadius: 10,
                    width: 30,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
                  }}
                >
                  <i className="fas fa-clapperboard"></i>
                </div>
              )}
            </div>

            {post.imageUrls.length > 1 ? (
              <div
                style={{
                  display: "flex",
                  paddingInline: 10,
                  paddingBottom: 10,
                }}
              >
                {/* Large image on the left */}
                {post.imageUrls.length > 0 && (
                  <div style={{ flex: 1.5 }}>
                    <img
                      src={post.imageUrls[0]}
                      alt="Post"
                      style={{
                        width: "100%",
                        height: "210px",
                        borderRadius: "10px",
                        backgroundColor: "#7f7f7f",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}

                <div
                  style={{
                    marginLeft: "10px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "center",
                  }}
                >
                  {/* Right column with stacked images */}
                  {post.imageUrls.slice(1, 3).map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        position: "relative",
                        marginBottom: index === 0 ? "10px" : "0",
                      }}
                    >
                      <img
                        src={item}
                        alt={`Post ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100px",
                          borderRadius: "10px",
                          backgroundColor: "#7f7f7f",
                          objectFit: "cover",
                        }}
                      />

                      {index === 1 && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "10px",
                            backgroundColor: "rgba(0, 0, 0, 0.36)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="fas fa-chevron-right"
                            style={{
                              color: "white",
                              fontSize: "20px",
                              marginBottom: "5px",
                            }}
                          ></i>
                          <p
                            style={{
                              color: "white",
                              fontFamily: "Montserrat, sans-serif",
                              fontSize: "12px",
                              lineHeight: "12px",
                              margin: 0,
                            }}
                          >
                            See more
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                  {/* View if there is no third image */}
                  {post.imageUrls.length < 3 && (
                    <div style={{ width: "100%", position: "relative" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "100px",
                          borderRadius: "10px",
                          backgroundColor: "rgba(0, 0, 0, 0.36)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fas fa-chevron-right"
                          style={{
                            color: "white",
                            fontSize: "20px",
                            marginBottom: "5px",
                          }}
                        ></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div
                style={{
                  paddingInline: 10,
                  paddingBottom: 10,
                }}
              >
                {/* guarded: a post with no images used to render src={undefined} */}
                {post.imageUrls.length === 1 ? (
                  <img
                    src={post.imageUrls[0]}
                    alt="Post"
                    loading="lazy"
                    style={{
                      width: "100%",
                      height: "210px",
                      borderRadius: "10px",
                      backgroundColor: "#7f7f7f",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "210px",
                      borderRadius: "10px",
                      backgroundColor: "rgba(255,255,255,0.06)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "rgba(255,255,255,0.35)",
                      fontSize: "26px",
                    }}
                  >
                    <i className="far fa-image"></i>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            style={{
              paddingInline: 10,
              paddingBottom: 10,
            }}
          >
            <p
              className="card-text"
              style={styles.description}
            >
              {post.description.length > 120 ? (
                <>
                  {post.description.slice(0, 120)} ...
                  <b>READ MORE</b>
                </>
              ) : (
                post.description
              )}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};

const styles = {
  row: {
    paddingBottom: "10px",
    color: "white",
    padding: "10px",
    lineHeight: "10px",
    position: "relative",
  },
  title: {
    fontSize: "0.8em",
  },
  date: {
    fontSize: "0.5em",
  },
  description: {
    fontSize: "0.8em",
    lineHeight: "1.2em",
    height: "80px",
    color: "white",
  },
};

export default Post;
